<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    ib-dialog(
        :autoclose="true",
        v-model="showInfoModal",
        class="info-dialog",
    )
        div(class="inner")
            div(class="modal-header")
                h3 {{ picked['ticker']}} -
                    span(v-if="type === 'stock'") {{ formatComp(picked['company']) }}
                    span(v-if="type === 'etf'") {{ formatComp(picked['etf_name']) }}
                    span(v-if="type === 'All'") {{ formatComp(picked['name']) }}
                a(@click="closeModal")
                    span(class="fg")
                        +icon-basic-cancel
            hr
            div(class="modal-body")
                div(class="form-group")
                    ib-row(v-if="type === 'etf'")
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('etf_name') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ formatComp(picked['etf_name']) }}
                    ib-row(v-if="type === 'stock'")
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('company_name') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ formatComp(picked['company']) }}
                    ib-row(v-if="type === 'All'")
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('name') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ formatComp(picked['name']) }}
                div(class="form-group")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('ticker') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ picked['ticker'] }}
                div(class="form-group")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('country') }}
                        ib-col(v-if="type === 'stock'", class="s6 m6 l6 xl4")
                            label {{ picked['company_cntry'] }}
                        ib-col(v-if="type === 'etf' || type === 'All'", class="s6 m6 l6 xl4")
                            label {{ picked['country'] }}
                div(class="form-group")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('sector') }}
                        ib-col(v-if="type === 'stock'", class="s6 m6 l6 xl4")
                            label {{ picked['industry'] }}
                        ib-col(v-if="type === 'etf' || type === 'All'", class="s6 m6 l6 xl4")
                            label {{ picked['sector'] }}
                div(class="form-group")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('price') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ picked['conv_price'] }}
                div(class="form-group", v-if="type === 'stock'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('mkt_cap') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ getFormat(picked['conv_mkt_cap']) }}
                div(class="form-group", v-if="type === 'etf'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('nav') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ getFormat(picked['conv_mkt_cap_nav']) }}
                div(class="form-group", v-if="type === 'All'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('mkt_cap') }} / {{ $t('nav') }}
                        ib-col(class="s6 m6 l6 xl4") 
                            label {{ getFormat(picked['mkt_nav']) }}
                div(class="form-group", v-if="type === 'stock'")
                    ib-row 
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('ev') }}
                        ib-col(class="s6 m6 l6 xl4")  
                            label {{ getFormat(picked['conv_ev_cur']) }}
                div(class="form-group", v-if="type === 'stock'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('rev') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ setExchRev(picked['ttmrev']) }}
                div(class="form-group", v-if="type === 'stock'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('earnings') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ setExchNI(picked['ttmebitd']) }}
                div(class="form-group", v-if="type === 'stock' || type === 'All'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('eps') }}
                        ib-col(v-if="type === 'stock'", class="s6 m6 l6 xl4")
                            label {{ getGrowth(picked['epsgrpct']) }}
                        ib-col(v-if="type === 'All'", class="s6 m6 l6 xl4")
                            label {{ getGrowth(picked['eps_1y']) }}
                div(class="form-group", v-if="type === 'etf'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('eps_growth') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ getGrowth(picked['eps_1y']) }}
                div(class="form-group")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('div') }}
                        ib-col(v-if="type === 'stock'", class="s6 m6 l6 xl4")
                            label {{ getYield(picked['divyield']) }}
                        ib-col(v-if="type === 'etf' || type === 'All'", class="s6 m6 l6 xl4")
                            label {{ getYield(picked['div_yield']) }}
                div(class="form-group")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('pe') }}
                        ib-col(v-if="type === 'stock'", class="s6 m6 l6 xl4")
                            label {{ getFixed(picked['peexclxor']) }}
                        ib-col(v-if="type === 'etf'", class="s6 m6 l6 xl4")
                            label {{ getRatio(picked['pe_ratio']) }}
                        ib-col(v-if="type === 'All'", class="s6 m6 l6 xl4")
                            label {{ getFixed(picked['pe']) }}
                div(class="form-group")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('peg') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ getRatio(picked['peg']) }}
                div(class="form-group", v-if="type === 'All'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('ev') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ getFormat(picked['ev']) }}
                div(class="form-group", v-if="type === 'All'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('rev') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ setExchRev(picked['rev']) }}
                div(class="form-group", v-if="type === 'All'")
                    ib-row
                        ib-col(class="s6 m6 l6 xl4")
                            label(class="control-label") {{ $t('earnings') }}
                        ib-col(class="s6 m6 l6 xl4")
                            label {{ setExchNI(picked['earnings']) }}
</template>
<script>
import { formatMixin } from '../js/formatting.js';

    export default {
        name: 'InfoModal',
        props: {
            picked: Object,
            type: String
        },
        data() {
            return {
                showInfoModal: false
            }
        },
        mixins: [formatMixin],
        methods: {
            closeModal() {
                this.showInfoModal = false;
            },
            show() {
                this.showInfoModal = true;
            }
        },
        mounted() {
            if (this.picked === null) {
                this.showInfoModal = false;
            }
        },
        watch: {
            picked: {
                handler: function() {
                    this.showInfoModal = true;
                },
                deep: true
            }
        }
    }
</script>

<style scoped lang="less">

    .info-dialog {
        display: block;
        .inner {
            .modal-header {
                padding: 20px 30px;
                h3 {
                    font-weight: 300;
                    font-size: 1.5rem;
                    color: #000;
                }
                a {
                    position: absolute;
                    top: 15px;
                    right: 10px;
                    margin: 0;
                    padding: 0;
                    width: 24px;
                    height: 24px;
                    color: #666;
                    background-color: rgba(0,0,0,0.05);
                    border: 1px solid transparent;
                    border-radius: 12px;
                }
            }
            .modal-body {
                .form-group {
                    label {
                        font-size: .875rem;
                        line-height: 1.25rem;
                        color: #666;
                        font-weight: 400;
                        margin-bottom: 5px;
                        display: block;
                        &.control-label {
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 1000px) and (orientation: landscape) {
        .info-dialog {
            height: 100%;
            width: 800px;
            .inner {
                .modal-header {
                    padding: 5px 10px;
                    h3 {
                        font-size: 1.25rem;
                    }
                    a {
                        top: 12px;
                    }
                }
                .modal-body {
                    padding: 10px 30px;
                    .form-group {
                        margin-bottom: 0;
                        label {
                            margin-bottom: 2px;
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 700px) and (orientation: landscape) {
        .info-dialog {
            max-height: 98%;
            max-width: 98%;
            .inner {
                .modal-header {
                    padding: 2px 10px !important;
                    h3 {
                        font-size: 1rem;
                    }
                    a {
                        top: 4px;
                    }
                }
                .modal-body {
                    padding: 2px 30px;
                }
            }
        }
    }
    @media (min-width: 601px) and (orientation: portrait) {
        .info-dialog {
            width: 800px;
        }
    }
    @media (max-width: 600px) {
        .info-dialog {
            height: 100vh;
            width: 98%;
            .inner {
                .modal-header {
                    padding: 20px 40px 10px 15px;
                }
                .modal-body {
                    .form-group {
                        margin: 0 0 5px 0;
                    }
                }
            }
        }
    }     
</style>